var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFakeDetected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1035 40.0075C22.1035 37.5079 23.9046 35.3789 26.3523 34.985C29.4309 34.4895 32.5678 34.4895 35.6464 34.985C38.0941 35.3789 39.8952 37.5079 39.8952 40.0075V40.5609C39.8952 42.0227 38.72 43.2077 37.2704 43.2077H24.7283C23.2787 43.2077 22.1035 42.0227 22.1035 40.5609V40.0075Z",
    stroke: "#479E64",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1886 23.0239C36.1886 25.9139 33.8653 28.2567 30.9993 28.2567C28.1334 28.2567 25.8101 25.9139 25.8101 23.0239C25.8101 20.1338 28.1334 17.791 30.9993 17.791C33.8653 17.791 36.1886 20.1338 36.1886 23.0239Z",
    stroke: "#479E64",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.875 17.7917C53.875 12.1768 48.1853 7.625 41.1667 7.625M8.125 40.6667C8.125 47.6853 12.6768 53.375 18.2917 53.375M18.2917 7.625C12.6768 7.625 8.125 12.1768 8.125 17.7917M41.1667 53.375C48.1853 53.375 53.875 47.6853 53.875 40.6667",
    stroke: "#479E64",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFakeDetected);
export default __webpack_public_path__ + "static/media/fakeDetected.524452bb3245b755aadb977a3dd2ad85.svg";
export { ForwardRef as ReactComponent };